<template>
    <el-dialog
        :visible.sync="show"
        append-to-body
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        width="800px"
        custom-class="triton-master-dialog"
        :fullscreen="fullScreen"
        @close="handleClose"
    >
        <template #title>
            创享达人主页
            <div class="custom-operation">
                <i
                    v-show="!fullScreen"
                    @click="fullScreen = true"
                    class="el-icon-full-screen"
                ></i>
                <i
                    v-show="fullScreen"
                    @click="fullScreen = false"
                    class="el-icon-crop"
                ></i>
            </div>
        </template>
        <div class="triton-master-container" ref="container">
            <div class="triton-master-viewer" v-show="!materialGuid" ref="inner">
                <div class="master-info">
                    <div class="user-info">
                        <img class="avatar" :src="renderData.shop.profilepicurl" alt=""/>
                        <div>
                            <div class="name">
                                {{ renderData.shop.shopname }}
                            </div>
                            <div
                                class="authentication"
                                v-if="renderData.publisher.publishertype"
                                :class="[renderData.entityCategory]"
                            >
                                创享达人-{{ renderData.publisher.publishertype | publisher }}认证
                            </div>
                        </div>
                    </div>
                    <p class="introduce">
                        {{ renderData.shop.introduce }}
                    </p>
                </div>
                <div class="master-material">
                    <div class="master-material-hd">
                        <div class="master-material-tt">TA上传的素材（{{ listData.total }}）</div>
                        <div>
                            <el-input
                                size="small"
                                v-model="listParams.searchtext"
                                placeholder="请输入关键字"
                                @blur="refreshList()"
                                @keyup.enter.native="refreshList()"
                            >
                                <i class="el-icon-search" slot="prefix"> </i>
                            </el-input>
                            <span @click="showScreen = !showScreen">
                                {{ showScreen ? '收起筛选' : '展开筛选' }}
                                <i class="el-icon-arrow-up" :class="{ 'el-icon-arrow-down': !showScreen }"> </i>
                            </span>
                        </div>
                    </div>
                    <screen-cells v-show="showScreen" @change="handleScreen"></screen-cells>
                    <div v-show="listData.total">
                        <material-list
                            ref="list"
                            :data="listData.list"
                            show-item-type
                            @listItemClick="listItemClick"
                        ></material-list>
                        <div
                            class="loading"
                            :class="{
                            animate: listData.list.length < listData.total
                        }"
                            v-show="loading"
                        >
                        <span>
                            {{ loadingText }}
                        </span>
                        </div>
                    </div>
                    <div v-show="!listData.total && listData.isLoad" class="none-data">
                        <span>
                            暂无数据
                        </span>
                    </div>
                </div>
            </div>
            <div class="material-detail-viewer" v-show="materialGuid">
                <div class="back">
                    <span @click="backMasterViewer">
                        <i class="el-icon-arrow-left"></i>
                        返回
                        <span> 【{{ renderData.shop.shopname }}】 的主页</span>
                    </span>
                </div>
                <div class="detail-wrap">
                    <material-detail :detail-data="materialDetailData" :show-similar="false"></material-detail>
                </div>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import MaterialList from '@/views/material-market/components/material-list.vue';
import ScreenCells from '@/views/material-market/components/screen-cells.vue';

export default {
    name: 'TritonMasterDialog',
    components: {
        MaterialList,
        ScreenCells,
        MaterialDetail: () => import('@/views/material-market/components/material-detail.vue') // 改为异步组件
    },
    props: {
        relationGuid: {
            type: String,
            default: ''
        },
        shopGuid: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            show: true,
            renderData: {
                publisher: {},
                shop: []
            },
            fullScreen: false,
            showScreen: false,
            screenData: [],
            listParams: {
                typecode: '', // 类别  热门推荐hot 其他类型给对应代码项或者guid
                searchtext: '', // 关键词
                pagesize_lowerlimit: '', // 素材页数下限
                pagesize_upperlimit: '', // 素材页数上限
                shopguid: '', // 素材所属店铺
                consumer: {
                    userguid: '',
                    consumerule: ''
                }, // 素材消费者
                sortingrule: '', // 排序规则
                pageindex: 0,
                pagesize: 6
            },
            listData: {
                list: [],
                total: 0,
                isLoad: false
            },
            loading: false,
            materialGuid: '',
            materialDetailData: {},
            keywordTimer: null
        };
    },
    filters: {
        publisher(data) {
            let text = '';
            if (data === 'enterprise') {
                text = '企业';
            } else if (data === 'person') {
                text = '个人';
            } else if (data === 'thirdplat') {
                text = '第三方平台';
            }
            return text;
        }
    },
    computed: {
        loadingText() {
            return this.listData.list.length < this.listData.total ? '正在加载' : '没有更多数据了';
        }
    },
    mounted() {
        this.listParams.shopguid = this.shopGuid;
        this.getMasterInfo();

        this.$nextTick(() => {
            this.$refs.container.addEventListener('scroll', this.handleScroll);
            // 使用 ResizeObserver 监听元素尺寸变化
            this.resizeObserver = new ResizeObserver(() => {
                let innerHeight = this.$refs.inner.clientHeight;
                let clientHeight = this.$refs.container.clientHeight;
                if (innerHeight < clientHeight && this.listData.list.length < this.listData.total) {
                    this.listParams.pageindex++;
                    this.getList();
                }
            });
            this.resizeObserver.observe(this.$refs.container);
        })
    },
    beforeDestroy() {
        this.$refs.container.removeEventListener('scroll', this.handleScroll);
        // 断开 ResizeObserver 的连接并清除
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        }
    },
    methods: {
        handleClose() {
            this.$emit('closeDialog')
        },
        getMasterInfo() {
            this.$Api
                .getMasterInfo({
                    userguid: this.relationGuid,
                    shopguid: this.shopGuid,
                    ishomepage: '0'
                })
                .then((data) => {
                    this.renderData = data;
                });
        },
        handleScreen(data) {
            this.listParams = {
                ...this.listParams,
                ...data
            };
            this.refreshList();
        },
        refreshList() {
            this.listParams.pageindex = 0;
            this.listData.list = [];
            // this.listData = {
            //     list: [],
            //     total: 0
            // };
            this.getList();
        },
        getList() {
            let params = {
                ...this.listParams
            };
            this.loading = true;
            this.$Api.getApplicationCenterList(params).then((data) => {
                this.loading = false;
                this.listData.list = this.listData.list.concat(data.materiallist);
                this.listData.total = data.pageinfo.totalnumcount;
                this.listData.isLoad = true;
                this.$nextTick(() => {
                    let innerHeight = this.$refs.inner.clientHeight;
                    let clientHeight = this.$refs.container.clientHeight;
                    if (innerHeight < clientHeight && this.listData.list.length < this.listData.total) {
                        this.listParams.pageindex++;
                        this.getList();
                    }
                });
            });
        },
        listItemClick(data) {
            this.materialGuid = data.materialguid;
            this.getMaterialDetail();
        },
        getMaterialDetail() {
            // TODO: 加载素材详情
            this.$Api
                .getMaterialDetail({
                    materialguid: this.materialGuid
                })
                .then((data) => {
                    this.materialDetailData = data;
                });
        },
        backMasterViewer() {
            this.materialGuid = '';
            this.materialDetailData = {};
        },
        handleScroll() {
            // 获取页面滚动位置
            const scrollTop = this.$refs.container.scrollTop;
            const clientHeight = this.$refs.container.clientHeight;
            const scrollHeight = this.$refs.container.scrollHeight;

            // 判断是否滚动到底部（距离底部20px时触发）
            if (scrollHeight - scrollTop - clientHeight <= 32) {
                // 如果还有更多数据
                if (!this.loading && this.listData.list.length < this.listData.total) {
                    this.listParams.pageindex++;
                    this.getList();
                } else {
                    this.loading = true;
                }
            }
        }
    }
};
</script>
<style lang="scss" scoped>
@import './style/triton-master-dialog.scss';
</style>
